import React from 'react';
import PropTypes from 'prop-types';

const Visibility = ({ visible, color = '#B5BDC5' }) => {
    if (visible) {
        return (
            <svg
                width="10px"
                height="10px"
                viewBox="0 0 10 10"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g
                    id="Svg-Icons/10px-(All-icons)/no-scale/visibility_off"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <g id="baseline-visibility_off-24px">
                        <path
                            d="M0,0 L10,0 L10,10 L0,10 L0,0 Z M0,0 L10,0 L10,10 L0,10 L0,0 Z M0,0 L10,0 L10,10 L0,10 L0,0 Z M0,0 L10,0 L10,10 L0,10 L0,0 Z"
                            id="Shape"
                        />
                        <path
                            d="M5.00227376,2.64473684 C6.25738972,2.64473684 7.27603456,3.70578947 7.27603456,5.01315789 C7.27603456,5.32105263 7.21691678,5.61 7.11232378,5.88 L8.44020009,7.26315789 C9.12687585,6.66631579 9.66803092,5.89421053 10,5.01315789 C9.21327876,2.93368421 7.27148704,1.46052632 4.99772624,1.46052632 C4.36107322,1.46052632 3.75170532,1.57894737 3.18781264,1.79210526 L4.17007731,2.81526316 C4.42928604,2.70631579 4.70668486,2.64473684 5.00227376,2.64473684 Z M0.45475216,1.35157895 L1.49158709,2.43157895 L1.70077308,2.64947368 C0.945884493,3.26052632 0.354706685,4.07526316 0,5.01315789 C0.786721237,7.09263158 2.72851296,8.56578947 5.00227376,8.56578947 C5.70713961,8.56578947 6.38017281,8.42368421 6.99408822,8.16789474 L7.18508413,8.36684211 L8.51750796,9.75 L9.0950432,9.14842105 L1.0322874,0.75 L0.45475216,1.35157895 Z M2.96953161,3.97105263 L3.67439745,4.70526316 C3.65165985,4.80473684 3.63801728,4.90894737 3.63801728,5.01315789 C3.63801728,5.79947368 4.24738518,6.43421053 5.00227376,6.43421053 C5.10231924,6.43421053 5.20236471,6.42 5.29786266,6.39631579 L6.00272851,7.13052632 C5.69804457,7.28684211 5.36152797,7.38157895 5.00227376,7.38157895 C3.7471578,7.38157895 2.72851296,6.32052632 2.72851296,5.01315789 C2.72851296,4.63894737 2.81946339,4.28842105 2.96953161,3.97105263 Z M4.92951342,3.60157895 L6.36198272,5.09368421 L6.37107776,5.01789474 C6.37107776,4.23157895 5.76170987,3.59684211 5.00682128,3.59684211 L4.92951342,3.60157895 Z"
                            id="Shape"
                            fill={color}
                        />
                    </g>
                </g>
            </svg>
        );
    }
    return (
        <svg
            width="10px"
            height="10px"
            viewBox="0 0 10 10"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                id="Svg-Icons/10px-(All-icons)/no-scale/visibility_on"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g id="baseline-remove_red_eye-24px">
                    <polygon id="Path-visibility-on" points="0 0 10 0 10 10 0 10" />
                    <path
                        d="M5,1.5 C2.72727273,1.5 0.786363636,2.95133333 0,5 C0.786363636,7.04866667 2.72727273,8.5 5,8.5 C7.27272727,8.5 9.21363636,7.04866667 10,5 C9.21363636,2.95133333 7.27272727,1.5 5,1.5 Z M5,7.33333333 C3.74545455,7.33333333 2.72727273,6.288 2.72727273,5 C2.72727273,3.712 3.74545455,2.66666667 5,2.66666667 C6.25454545,2.66666667 7.27272727,3.712 7.27272727,5 C7.27272727,6.288 6.25454545,7.33333333 5,7.33333333 Z M5,3.6 C4.24545455,3.6 3.63636364,4.22533333 3.63636364,5 C3.63636364,5.77466667 4.24545455,6.4 5,6.4 C5.75454545,6.4 6.36363636,5.77466667 6.36363636,5 C6.36363636,4.22533333 5.75454545,3.6 5,3.6 Z"
                        id="Shape"
                        fill={color}
                        className="icon-color"
                    />
                </g>
            </g>
        </svg>
    );
};

Visibility.propTypes = {
    color: PropTypes.string,
    visible: PropTypes.bool,
};

export default Visibility;
